import React, { useEffect, useRef } from "react";
import { cn } from "@/lib/utils";

const TextareaAuto = React.forwardRef(({ className, onHeightChange, ...props }, ref) => {
  const textareaRef = useRef(null);
  const combinedRef = ref || textareaRef;

  const adjustHeight = () => {
    const textarea = combinedRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;

      if (onHeightChange) {
        onHeightChange(textarea.scrollHeight);
      }
    }
  };

  useEffect(() => {
    adjustHeight();
  }, [props.value]);

  const handleInput = (e) => {
    adjustHeight();
    if (props.onInput) {
      props.onInput(e);
    }
  };

  return (
    <textarea
      className={cn(
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-4 text-sm md:text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-none overflow-hidden items-center",
        className
      )}
      ref={combinedRef}
      rows={1}
      onInput={handleInput}
      style={{
        lineHeight: "2",
        paddingTop: "16px",
        paddingBottom: "16px",
        display: "flex",
        alignItems: "center",
      }}
      {...props}
    />
  );
});

TextareaAuto.displayName = "TextareaAuto";

export { TextareaAuto };
